<template>
  <div class="d-flex align-center">
    <div v-if="(!tags || tags.length == 0) && !show_input">
      <v-chip
        @click="showTagInput"
        small
        class="mr-2 px-2 tags font-weight-bold"
        color="backgroundLight"
        text-color="primaryGrey"
        label
      >
        Add Tag
        <v-icon small right> mdi-plus </v-icon>
      </v-chip>
    </div>
    <div v-else>
      <v-chip
        v-for="(tag, index) in tags"
        :key="`${index}_${tag}_tag`"
        small
        class="mr-2 px-2 tags font-weight-bold"
        color="secondary"
        label
        close
        @click:close="updateTags(true, tag)"
      >
        {{ tag }}
      </v-chip>
      <v-icon color="primaryGrey" @click="showTagInput" v-if="!show_input" right> mdi-plus-box </v-icon>
    </div>
    <div v-if="show_input">
      <v-combobox
        dense
        class="tag-input"
        @keydown="newTagInputUpdated"
        @blur="onInputBlur"
        @change="inputUpdated"
        :items="tags_list"
        outlined
        v-model="tag"
        hide-details
        ref="tagInput"
      ></v-combobox>
    </div>
  </div>
</template>

<script>
import { axios_post } from "../services/vt_service";
import { scv } from "../services/powerdata";

export default {
  name: "TagsVT",
  props: {
    device_id: {
      type: String,
      required: true,
    },
  },
  watch: {},
  data: function () {
    return {
      tags: null,
      show_input: false,
      tag: "",
    };
  },
  created() {},
  mounted() {
    this.tags =
      this.$store.state.tags && this.$store.state.tags[this.device_id] ? this.$store.state.tags[this.device_id] : [];
  },
  methods: {
    showTagInput() {
      this.show_input = true;
      this.$nextTick(() => {
        this.show_input && this.$refs.tagInput.focus();
      });
    },
    newTagInputUpdated(event) {
      var code = event.keyCode ? event.keyCode : event.which;
      if (code == 9) event.preventDefault();
      if (code == 13 || code == 27 || code == 9) {
        //Enter keycode, ESC, Tab
        if (code == 13 || code == 9) {
          if (this.tag) {
            this.tags.push(this.tag);
            this.updateTags();
          }
        }
        this.tag = "";
      }
    },
    inputUpdated() {
      if (this.tag && !this.tagExistsForDevice(this.tag)) {
        this.tags.push(this.tag);
        this.updateTags();
      }
      this.$nextTick(() => {
        this.tag = "";
      });
    },
    tagExistsForDevice(tag) {
      if (this.$store.state.tags && this.$store.state.tags[this.device_id]) {
        return this.$store.state.tags[this.device_id].indexOf(tag) != -1;
      }
      return false;
    },
    onInputBlur() {
      this.show_input = false;
      this.tag = "";
    },
    async updateTags(remove, tag) {
      let payload = {};
      payload["device_id"] = this.device_id;
      if (remove) {
        payload["tag"] = tag;
        payload["remove"] = true;
        this.tags = this.tags.filter((e) => e != tag);
      } else {
        payload["tag"] = this.tag;
      }
      await axios_post(scv.update_scavenger_tags, payload);
      this.tag = "";
      this.$store.dispatch("loadScvTags");
    },
  },
  computed: {
    tags_list: function () {
      const SUGGESTION_LIMIT = 10;
      return this.$store.state.tags && this.device_id && this.$store.state.tags_list
        ? this.$store.state.tags_list
            .filter((e) => {
              return !this.tagExistsForDevice(e);
            })
            .slice(0, SUGGESTION_LIMIT)
        : [];
    },
  },
};
</script>
<style scoped>
::v-deep .tag-input.v-text-field .v-input__control .v-input__slot {
  max-height: 22px !important;
  font-size: 11px !important;
  max-width: 110px;
  box-shadow: none;
}
::v-deep .tag-input.v-text-field .v-input__control .v-input__slot .v-select__slot {
  height: 25px !important;
}

::v-deep .tag-input.v-text-field .v-input__control .v-input__slot .v-input__append-inner {
  display: none;
}

::v-deep .v-chip .v-chip__close.v-icon {
  font-size: 14px !important;
}
</style>
